import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";
import task05 from "./layouts/task-05/task";

const lesson: Lesson = {
  id: "7eb85694-fbf1-4b0f-8ac4-abb4ce028ca0",
  publicId: "21",
  name: "Resonance in a cavity",
  body: [principle01, task01, task02, task03, task04, task05],
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
};

export default lesson;
